import { render, staticRenderFns } from "./ScanAbnormal.vue?vue&type=template&id=41ae4a55&scoped=true&"
import script from "./ScanAbnormal.vue?vue&type=script&lang=js&"
export * from "./ScanAbnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ae4a55",
  null
  
)

export default component.exports